import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import TeamCheckoutDialog from "@/components/TeamCheckoutDialog";
import { Lock, ShieldCheck, X } from "lucide-react";

export default function UpgradeBanner() {
  const [billing, setBilling] = useState(null);
  const [foundational, setFoundational] = useState(null);
  const [dialog, setDialog] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("upgrade_dismissed") === "1");

  useEffect(() => {
    api.get("/billing/me").then(({ data }) => setBilling(data)).catch(() => {});
    api.get("/billing/foundational-count").then(({ data }) => setFoundational(data)).catch(() => {});
  }, []);

  if (!billing || billing.type !== "team" || billing.paid || dismissed) return null;

  const buy = () => setDialog(true);

  return (
    <div
      className="rounded-xl p-4 mb-6 flex items-center gap-4 border"
      style={{ borderColor: "rgba(217,4,41,0.5)", backgroundColor: "rgba(217,4,41,0.08)" }}
      data-testid="upgrade-banner"
    >
      <div className="hidden sm:flex items-center justify-center w-11 h-11 rounded-full shrink-0" style={{ backgroundColor: "var(--brand-secondary)" }}>
        <Lock className="h-5 w-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <div className="text-[10px] tracking-[0.3em] font-bold uppercase" style={{ color: "var(--brand-secondary)" }}>Team plan</div>
          <span className="inline-flex items-center gap-1 text-[10px] text-white/60"><ShieldCheck className="h-3 w-3" /> Up to 40 athletes · $25/seat past 40</span>
        </div>
        <div className="font-display font-bold text-white text-base mt-0.5 leading-tight">
          Unlock your team plan for <span style={{ color: "var(--brand-secondary)" }}>$1,495/yr</span> — annual, all future features included.
        </div>
      </div>
      <Button onClick={buy} className="text-white font-bold rounded-full px-5 red-glow shrink-0" style={{ backgroundColor: "var(--brand-secondary)" }} data-testid="upgrade-banner-buy">
        Configure team
      </Button>
      <button onClick={() => { setDismissed(true); sessionStorage.setItem("upgrade_dismissed", "1"); }} className="text-white/40 hover:text-white shrink-0" title="Dismiss" data-testid="upgrade-banner-dismiss">
        <X className="h-4 w-4" />
      </button>
      <TeamCheckoutDialog open={dialog} onOpenChange={setDialog} packageId="team" foundationalRemaining={foundational?.remaining ?? 0} />
    </div>
  );
}
